// --------------------------------------------------------
// RECEITUARIO FIELD - ReceituarioField
// --------------------------------------------------------

// --------------------------------------------------------
// GENERAL
// --------------------------------------------------------
import React from 'react'
import { H3 } from '../../../../../../../components/UI/generalLayout/Layout.styled'
import { removeFieldFromList } from '../../../../../../../helpers/CareLineHelperFunctions'
import { MediumInput } from '../DetailsAttendanceRecord.styled'
import { ReactComponent as Trash } from '../../../../../../../assets/imgs/trashBin.svg';
import AddButtonField from '../AddButtonField';
import { addValueToObject } from '../../../../../../../helpers/HelperFunctions';

// --------------------------------------------------------

// --------------------------------------------------------
// IMPORTS
// --------------------------------------------------------
// --------------------------------------------------------

// --------------------------------------------------------
// RECEITUARIO FIELD INTERFACE
// --------------------------------------------------------

interface IReceituarioField {
    receituarios: any;
    receituariosEspeciais: any;
    setReceituarios: (value: any) => void;
    setReceituariosEspeciais: (value: any) => void;
    isViewState: boolean;
    useClinicFrame?: boolean;
    profile?: string;
}
/**
/**
 * A component that renders a Component description here.
 *
 * @param props The component props.
 * @returns The component JSX.
 */
const ReceituarioField = ({ receituarios, receituariosEspeciais, setReceituarios, setReceituariosEspeciais, isViewState, useClinicFrame, profile }: IReceituarioField) => {
    // --------------------------------------------------------
    // RECEITUARIO FIELD PRIVATE DECLARATIONS
    // --------------------------------------------------------
    const onAddButtonClick = () => {
        setReceituariosEspeciais((prev: any) => {
            const list = [...prev];
            list.push({ descricao: '' })
            return list;
        })
    }
    const onAddReceituarioButtonClick = () => {
        setReceituarios((prev: any) => {
            const list = [...prev];
            list.push({ descricao: '' })
            return list;
        })
    }
    // --------------------------------------------------------

    // --------------------------------------------------------
    const isReceituarioDisabled = isViewState || Boolean(useClinicFrame && profile === 'MED');

    return (
        <>
            <div>
                <H3>Receituário</H3>
                {receituarios.map((r: any, index: number) => {
                    return <div style={{ marginTop: 10 }} key={index}>
                        <MediumInput
                            value={r.descricao}
                            disabled={isReceituarioDisabled}
                            onChange={(event: any) => {
                                addValueToObject({ descricao: event.target.value }, index, setReceituarios)
                            }}
                            placeholder="Digite os medicamentos" />
                        {index !== 0 && !isReceituarioDisabled && (<div style={{ textAlign: 'center' }}>
                            <Trash
                                style={{ marginTop: 10, cursor: 'pointer' }}
                                onClick={() => { setReceituarios(removeFieldFromList(receituarios, index)) }}
                            />
                        </div>)}
                    </div>
                })}

                {!isReceituarioDisabled && (<AddButtonField
                    buttonText='Adicionar outro receituário'
                    onClickFunction={onAddReceituarioButtonClick}
                />)}
            </div>
            {!useClinicFrame &&
                <div>
                    <H3>Receituário especial</H3> {/* Será uma lista que pode ser aumentada ao adicionar outro especial */}
                    {receituariosEspeciais.map((r: any, index: number) => {
                        return <div style={{ marginTop: 10 }}>
                            <MediumInput
                                value={r.descricao}
                                disabled={isViewState}
                                onChange={(event: any) => {
                                    addValueToObject({ descricao: event.target.value }, index, setReceituariosEspeciais)
                                }}
                                placeholder="Digite os medicamentos" />
                            {index !== 0 && !isViewState && (<div style={{ textAlign: 'center' }}>
                                <Trash
                                    style={{ marginTop: 10, cursor: 'pointer' }}
                                    onClick={() => { setReceituariosEspeciais(removeFieldFromList(receituariosEspeciais, index)) }}
                                />
                            </div>)}
                        </div>
                    })}

                    {!isViewState && (<AddButtonField
                        buttonText='Adicionar outro receituário especial'
                        onClickFunction={onAddButtonClick}
                    />)}
                </div>
            }
        </>
    )
    // --------------------------------------------------------
}

export default ReceituarioField